import React from 'react';
import {isMobile} from 'react-device-detect';
import './Filter.scss';

const filter = '/img/icons/filters.svg';

const ButtonFilter = ({ dropdown }) => {  
  return (
    <button 
      className="button-filter"
      style={isMobile? { top: 16, right:16, padding:0 }: null}
      onClick={dropdown && dropdown}
    >
      <img
        src={filter}
        style={{ marginRight: isMobile? 0:8 }}
        width="24px"
        height="24px"
        alt="icono de filtro"
      />
      <span
        style={{
          color: '#10587f',
          fontSize: '14px',
          marginRight: '10px',
          verticalAlign: '30%',
          display: isMobile? 'none':'initial',
        }}
      >
        Filtrar
      </span>
    </button>
  );
};

export default ButtonFilter;
